import React from "react";
import ChatIndicatorListItem from "./ChatIndicatorListItem";

const ChatIndicator = ({
  userInboxList,
  me,
  setUserInboxLastActivity,
  unreadMessages,
  setForceWindowOpen,
}) => {
  const INDICATOR_MAX = 9;
  const show = () => userInboxList && Object.entries(userInboxList).length > 0;

  const hiddenChats = () => {
    const len = Object.entries(userInboxList).length;
    return `+${len > INDICATOR_MAX ? INDICATOR_MAX : len}`;
  };

  const hasUnreadMessages = () => {
    return Object.entries(unreadMessages).some(
      (inbox) => inbox[1].count > 0 && inbox[1].isListItem
    );
  };

  return (
    <>
      {show() && (
        <div
          className={` chat-indicator justify-content-center align-bottom text-end`}
        >
          <div className="btn-group dropup caret-off">
            <button
              type="button"
              className="btn p-0 m-0"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="p-2 font-weight-bold me-3">
                {hiddenChats()}
                {hasUnreadMessages() && (
                  <span className="chat-indicator-unread"></span>
                )}
              </span>
            </button>
            {/* <div className="dropdown-wrapper"> */}
              <div className="dropdown-wrapper dropdown-menu custom-dropdown py-0">
                <div className="dropdown-items">
                  {userInboxList &&
                    Object.entries(userInboxList)
                      .reverse()
                      .map((inbox, i) => {
                        const [inboxUUID, data] = inbox;

                        if (data.members) {
                          return (
                            <ChatIndicatorListItem
                              {...data.props}
                              //   onClick={() =>
                              //     handleListItemClick(inboxUUID, false)
                              //   }
                            />
                          );
                        } else {
                          return <></>;
                        }
                      })}
                </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatIndicator;
